import client from './client';

/**
 * Fetch everything the Send Hot Potato form needs: message + graphic options,
 * the flat cost, the current SpudCoin balance, and the user's friends.
 * @returns {Promise<{messages:Array,graphics:Array,cost_spudcoin:number,spudcoin_balance:number,friends:Array}>}
 */
export const getHotPotatoOptions = async () => {
    const response = await client.get('/hot_potato/options');
    return response.data;
};

/**
 * Send a Hot Potato to a friend. SpudCoin is charged once, on success only.
 * @param {{recipient_id:string,message_id:string,graphic_id:string}} payload
 * @returns {Promise<{message:string,id:string,spudcoin_spent:number,spudcoin_balance:number}>}
 */
export const sendHotPotato = async ({ recipient_id, message_id, graphic_id }) => {
    const response = await client.post('/hot_potato/send', { recipient_id, message_id, graphic_id });
    return response.data;
};

/**
 * Fetch the Hot Potatoes the current user has received and sent.
 * @returns {Promise<{received:Array,sent:Array,cost_spudcoin:number}>}
 */
export const getHotPotatoes = async () => {
    const response = await client.get('/hot_potato');
    return response.data;
};

/**
 * Lightweight unread count for Profile / nav badges.
 * Unread = received Hot Potatoes the user has not opened yet.
 * @returns {Promise<{unread_count:number}>}
 */
export const getHotPotatoUnreadCount = async () => {
    const response = await client.get('/hot_potato/unread_count');
    return response.data;
};

/**
 * Fetch a single Hot Potato. Only its sender or recipient may view it.
 * @param {string} hotPotatoId
 */
export const getHotPotato = async (hotPotatoId) => {
    const response = await client.get(`/hot_potato/${hotPotatoId}`);
    return response.data;
};

/**
 * Reactions on one Hot Potato. Only its sender or recipient may read them.
 * @param {string} hotPotatoId
 * @returns {Promise<{reactions:Array}>}
 */
export const getHotPotatoReactions = async (hotPotatoId) => {
    const response = await client.get(`/hot_potato/${hotPotatoId}/reactions`);
    return response.data;
};

/**
 * Reaction summaries for many Hot Potatoes, keyed by id.
 * @param {string[]} hotPotatoIds
 * @returns {Promise<{reactions:Object}>}
 */
export const getHotPotatoReactionsBatch = async (hotPotatoIds) => {
    const response = await client.post('/hot_potato/reactions/batch', { hot_potato_ids: hotPotatoIds });
    return response.data;
};

/**
 * Add a reaction, or remove it if this user already reacted with that emoji.
 * @param {string} hotPotatoId
 * @param {string} emoji
 */
export const toggleHotPotatoReaction = async (hotPotatoId, emoji) => {
    const response = await client.post(`/hot_potato/${hotPotatoId}/reactions`, { emoji });
    return response.data;
};

/**
 * Resolve a graphic filename from the catalog to its public URL.
 * @param {string} filename e.g. "oven_mitts.svg"
 */
export const hotPotatoGraphicUrl = (filename) => (filename ? `/hot-potato/${filename}` : '');
